import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconError = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	fill: "none",
	viewBox: "0 0 15 15",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#E00751",
		d: "M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm0 13.636A6.133 6.133 0 0 1 1.364 7.5 6.132 6.132 0 0 1 7.5 1.364 6.133 6.133 0 0 1 13.636 7.5 6.133 6.133 0 0 1 7.5 13.636z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#E00751",
		d: "M7.5 9.034a.684.684 0 0 0 .682-.682v-3.92A.684.684 0 0 0 7.5 3.75a.684.684 0 0 0-.682.682v3.92c0 .375.307.682.682.682zm0 2.438a.852.852 0 1 0 0-1.705.852.852 0 0 0 0 1.705z"
	})]
});
export default SvgIconError;
